import React, { useEffect, useState } from "react";
import axios from "axios";
import { serverAPI } from "../index";
import {
  Container,
  HStack,
  VStack,
  Image,
  Heading,
  Text,
} from "@chakra-ui/react";
import Loader from "./Loader";
import ErrorComponent from "./ErrorComponent";

const Exchanges = () => {
  const [exchanges, SetExchanges] = useState([]);
  //used to show till data is loaded
  const [loading, setLoading] = useState(true);
  //for showing error
  const[isError,setError]=useState(false)

  useEffect(() => {
    const fetchExchanges = async () => {
      try {
        const { data } = await axios.get(serverAPI + "/exchanges"); // or {data}
      //actually its : 'https://api.coingecko.com/api/v3/exchanges' but we have put predefined link in serverAPI
      SetExchanges(data);
      setLoading(false);
      //console.log(data);
      } catch (error) {
        setError(true)
        setLoading(false)
      }
    };
    fetchExchanges();
  }, []);

  if(isError)return <ErrorComponent message={"Error While Fetching Exchanges"}/>

  return (
    <Container maxW={"container.xl"}>
      {loading ? (
        <Loader />
      ) : (
        <>
          <HStack wrap={"wrap"} justifyContent={"space-evenly"}>
            {exchanges.map((i) => (
              <ExchangeCard
                key={i.id}
                name={i.name}
                img={i.image}
                rank={i.trust_score_rank}
                url={i.url}
              />
            ))}
          </HStack>
        </>
      )}
    </Container>
  );
};

//img,name etc are returned my api
//h/w: what is the difference between _blank and blank
//Ans: tabs are not wasted 
const ExchangeCard = ({ name, img, rank, url }) => {
  return (
    <a href={url} target={"blank"}>
      <VStack
        w={"52"}
        shadow={"outline"}
        p={"8"}
        borderRadius={"lg"}
        transition={"all 0.3s"}
        m={"4"}
        css={{
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
      >
        <Image
          src={img}
          w={"10"}
          h={"10"}
          objectFit={"contain"}
          alt={"exchanges"}
        />
        <Heading size={"md"} noOfLines={1}>
          {rank}
        </Heading>
        <Text noOfLines={1}>{name}</Text>
        {/*noOfLines is used, if any word is overflowed instead of that word comming in next line it will show ... */}
      </VStack>
    </a>
  );
};

export default Exchanges;
